import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader, CardBlock} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import Loader from '../../../components/Loader';
import {withRouter} from 'react-router-dom';
import { setSearchScope } from '../../../helpers';

class Overview extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [
        {
            Header: 'Bekijken',
            accessor: 'id',
            Cell: props => <span><a href={'/#/clients/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-eye"></i> Bekijken</a></span>
        }
        ]

    }

	componentWillMount() {
    	this.props.updateSearchData(this.props.clientData.data)
		setSearchScope('clients');

    }
      
    componentDidMount() {
        window.scrollTo(0, 0)
    }

	render() {
        return (
               this.props.clientData.data ?
                <Card>
    				<CardHeader><Search filter={[{'is_active': 1}, {'in_active': 0}]} data={this.props.clientData.data} keys_to_filter={['name', 'customer_id', 'addresses.street', 'addresses.zipcode', 'addresses.city']}/></CardHeader>
                    <CardBody>
                        <CardTitle><i className="fa fa-align-justify"></i> Klanten overzicht</CardTitle>
                        <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.clientData.data} columns={this.props.clientData.columns} />
                    </CardBody>
                </Card>
               : <Loader />

        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Overview))



// WEBPACK FOOTER //
// ./src/views/Clients/Overview/index.js